import type { IQAAnswer } from "./types";

interface IAiSearchQAProps {
    qaAnswers: Record<string, IQAAnswer>;
}

export function AiSearchQA(props: IAiSearchQAProps) {
    const { qaAnswers } = props;
    const answers = Object.values(qaAnswers).filter(Boolean);

    if (answers.length === 0) {
        return null;
    }

    return (
        <div className="ai-search-qa" data-testid="ai-search-qa">
            {answers.map((answer) => (
                <div key={answer.source} className="ai-search-qa-card">
                    <div className="ai-search-qa-label">AI Answer</div>
                    <div className="ai-search-qa-text">{answer.text}</div>
                    {answer.source_title && (
                        <div className="ai-search-qa-source">Source: {answer.source_title}</div>
                    )}
                </div>
            ))}
        </div>
    );
}
